import { FAQS } from "../data/faq";
import styles from "./FAQ.module.css";

export function FAQ() {
  return (
    <section id="faq" className={styles.section} aria-labelledby="faq-heading">
      <div className={`container-wide ${styles.inner}`}>
        <div className={styles.intro}>
          <p className={styles.kicker}>Before you book</p>
          <h2 id="faq-heading" className={styles.heading}>Clear answers, <em>before the first visit.</em></h2>
          <p className={styles.lede}>The practical details in one place. Current availability lives on Vagaro; questions are always welcome before you choose a service.</p>
        </div>
        <div className={styles.list}>
          {FAQS.map((item) => (
            <details key={item.question} className={styles.item}>
              <summary className={styles.question}>{item.question}</summary>
              <p className={styles.answer}>{item.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
